module.exports = __webpack_public_path__ + "img/4-low.b431d66b.jpg";